import * as fromModels from '../../models';

import { Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
/**************************************************************************************************/
/*   File: /src/app/shared/services/utils/ambiti.service.ts                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { RootState } from '../../../stores/states/root/state';
import { Store } from '@ngrx/store';
import { environment } from '../../../../environments/environment';
import { getCurrentLanguage } from '../../../stores/selectors/ui/selectors';

/**
 * The ambiti service
 */
@Injectable({
  providedIn: 'root'
})
export class AmbitiService {
  /**
  * The api url for authorization users
  */
  apiUrl = environment.serviceHost;
  /**
   * The api path
   */
  apiPath = environment.apiPath;
  /**
   * The geo data type api url
   */
  ambiti = 'ambiti';
  /**
   * The current lang
   */
  currentLang: string;

  /**
   * The constructor
   * Store will be replaced when proxy is set
   * Because headers will be set by him
   * @param {HttpClient} http
   * @param {Store<RootState>} store
   */
  constructor(private http: HttpClient, private store: Store<RootState>) {
    // Due to testing pipeable operator
    // tslint:disable-next-line
    this.store.select(
      getCurrentLanguage
    ).subscribe((language) => {
      this.currentLang = language.isoCode === 'en' ? environment.defaultLanguage : language.isoCode;
    });
  }

  /**
   * Get all ambiti by plan code
   * @param {string} code The code
   */
  getAllAmbitiByPlanCode(code: string): Observable<fromModels.Ambito[]> {
    if (code === undefined) {
      return of([]);
    }
    return this.http.get<fromModels.Ambito[]>(
      `${this.apiUrl}${this.apiPath}ambiti-available-portal-by-plan-and-date?planCode=${code}`,
      {
        headers: {
          'X-NewPlan-Locale': this.currentLang
        }
      }
    );
  }

  /**
   * Get ambiti by code
   * @param {string} code The code
   */
  getApprovedAmbitiByPlanCode(code: string): Observable<fromModels.Ambito[]> {
    if (code === undefined) {
      return of([]);
    }
    return this.http.get<fromModels.Ambito[]>(
      `${this.apiUrl}${this.apiPath}ambiti-available-portal-approved-by-plan-and-date?planCode=${code}`,
      {
        headers: {
          'X-NewPlan-Locale': this.currentLang
        }
      }
    );
  }

  /**
   * Get all ambiti
   */
  getAllAmbiti(): Observable<fromModels.Ambito[]> {
    return this.http.get<fromModels.Ambito[]>(
      `${this.apiUrl}${this.apiPath}ambiti/all`,
      {
        headers: {
          'X-NewPlan-Locale': this.currentLang
        }
      }
    );
  }


}
